import { LoadingSkeleton } from 'sonata-react-components';

import './audienceInsights.scss';
import './audienceInsightsSkeleton.scss';
import './BrandSection/brandSection.scss';
import './DemographicItem/demographicItem.scss';

export function AudienceInsightsSkeleton() {
  return (
    <div className="audienceInsights">
      <div className="audienceInsights__insightsContent">
        <div className="audienceInsightsSkeleton__figure">
          <LoadingSkeleton height="100%" width="100%" />
        </div>
        <div className="audienceInsights__insightsBody">
          <div className="audienceInsightsSkeleton__header">
            <LoadingSkeleton height={22} width="45%" />
            <LoadingSkeleton height={16} width="65%" />
          </div>
          <div className="audienceInsights__demographics">
            <div className="demographicItem">
              <LoadingSkeleton height={12} width={50} />
              <LoadingSkeleton height={20} width={70} />
            </div>
            <div className="audienceInsights__demographicSeparator" />
            <div className="demographicItem">
              <LoadingSkeleton height={12} width={50} />
              <LoadingSkeleton height={20} width={80} />
            </div>
            <div className="audienceInsights__demographicSeparator" />
            <div className="demographicItem">
              <LoadingSkeleton height={12} width={50} />
              <LoadingSkeleton height={20} width={80} />
            </div>
          </div>
          <div className="audienceInsights__body">
            <div className="audienceInsights__interests">
              <LoadingSkeleton height={14} width="55%" />
              {Array.from({ length: 5 }).map((_, i) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
                <LoadingSkeleton height={16} key={i} width={`${75 - i * 5}%`} />
              ))}
            </div>
            <div className="audienceInsights__primaryValues">
              <LoadingSkeleton height={14} width="55%" />
              {Array.from({ length: 3 }).map((_, i) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
                <LoadingSkeleton height={16} key={i} width={`${80 - i * 5}%`} />
              ))}
            </div>
          </div>
          <div className="audienceInsights__coreNeeds">
            <LoadingSkeleton height={14} width="40%" />
            <LoadingSkeleton height={14} width="90%" />
            <LoadingSkeleton height={14} width="75%" />
          </div>
        </div>
      </div>

      <div className="audienceInsights__affinitiesContent">
        <div className="audienceInsightsSkeleton__affinitiesHeader">
          <LoadingSkeleton height={20} width="70%" />
        </div>
        <div className="brandSection">
          <LoadingSkeleton height={12} width="35%" />
          <div className="brandSection__list">
            {Array.from({ length: 8 }).map((_, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
              <LoadingSkeleton height={66} key={i} width="100%" />
            ))}
          </div>
        </div>
        <div className="brandSection">
          <LoadingSkeleton height={12} width="40%" />
          <div className="brandSection__list">
            {Array.from({ length: 8 }).map((_, i) => (
              // biome-ignore lint/suspicious/noArrayIndexKey: static skeleton — index is stable
              <LoadingSkeleton height={66} key={i} width="100%" />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
